import { Routes, Route, Navigate } from "react-router-dom";

// Material Dashboard 2 React routes
// import MasterLayout from "../../Layouts/MasterLayout";
import TopbarLayout from "../../Layouts/TopbarLayout";
import useRoutes from "./routes";

export default function Default() {
  const routes = useRoutes();
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.items && route.items.length) {
        return getRoutes(route.items);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <TopbarLayout routes={routes.filter((item) => (item.title ? true : false))}>
      <Routes>
        {getRoutes(routes)}
        {/* <Route path="*" element={<Navigate to="/app/dashboard" />} /> */}
      </Routes>
    </TopbarLayout>
  );
}
